import AboutOverlay from "./AboutOverlay";
export default AboutOverlay;


// WEBPACK FOOTER //
// ./src/AboutOverlay/index.js